import { useEffect, useState } from "react";
import { LookupService } from "../../../app/core/lookup.service";
import { useParams } from "react-router-dom";
import { FormatIndianDate } from "../../../app/utility/formatIndianDate";
import { Breadcrumb } from "../../../components/breadcum";
import { OndcService } from "../../../app/core/ondc.service";
import toast from "react-hot-toast";
import { Card } from "react-bootstrap";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import { IMAGE_PATH } from "../../../config";
import noImage from "../../../assets/images/no-image.webp";

export const ONDCIgmView = () => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [ticketsData, setTicketsData] = useState<any>();
  const [replayData, setReplayData] = useState<any>();
  const [replayTicket, setReplayTicket] = useState<boolean>(false);
  const [resolution, setResolution] = useState<boolean>(false);
  const [actionData, setActionData] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const [productsData, setProductsData] = useState<any>([]);
  const [resolutionData, setResolutionData] = useState<any>(
    {
      item: "",
      refund_amt: "",
      description: ""
    }
  );
  const [requestId, setRequestId] = useState<string>("");

  useEffect(() => {
    setTicketsData("");
    loadTickets();
  }, []);
  const loadTickets = async () => {
    setLoading(true);
    try {
      const messageData: any = await OndcService.getOndcIgmData({ id: params.id });
      setTicketsData(messageData?.results[0]);
      if (messageData?.results[0]?.message?.issue?.order_details?.provider_id) {
        getUserData(messageData?.results[0]?.message?.issue?.order_details);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getUserData = async (data: any) => {
    let payload = { id: data?.provider_id };
    setLoading(true);
    try {
      let encrytedData = encrypt(JSON.stringify(payload));
      const res = await ApisService.getOrganizationData("findById", encrytedData);
      const userData = JSON.parse(dataDecrypt(res.data.data));
      setUserData(userData[0]);
      loadProducts(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function loadProducts(data:any): Promise<void> { 
    setLoading(true);
    try {
      let encryptedData = encrypt(JSON.stringify({id:data?.provider_id}));
      const res = await ApisService.productApi(
        "findProductList_v2",
        encryptedData
      );
      const productsData = JSON.parse(dataDecrypt(res.data.data));
      const product = productsData.results;
      let igmProductData = [];
      for (const item of data?.items) {
       igmProductData = product.filter((el:any)=> el._id === item?.id);
      }
      setProductsData(igmProductData);
      setLoading(false);
    } catch (error) {
      setLoading(false);

    }
  }

  const writeReplay = () => {
    setReplayTicket(true);
    setActionData("");
    setRequestId("");
    setReplayData("");
  };

  const sendResolution = () => {
    const refsData = ticketsData?.message?.issue?.refs;
    if (refsData && refsData.length > 0) {
      for (const obj of refsData) {
        if (obj?.ref_type === "ITEM") {
          setResolutionData((prev: any) => ({
            ...prev,
            item: obj?.ref_id
          }));
        }
      }
    }
    setResolution(true);
  };

  const onSubmitData = async () => {
    if (actionData?.length > 0 && actionData !== "NEED-MORE-INFO") {
      setLoading(true);
      try {
        let payload = {
          id: params.id,
          reason: replayData,
          action: actionData,
        };
        const messageData = await await OndcService.updateOndcIgmData(payload);
        setReplayTicket(false);
        setLoading(false);
        loadTickets();
      } catch (error) {
        setLoading(false);
      }
    } else if (actionData?.length > 0 && actionData === "NEED-MORE-INFO") {
      setLoading(true);
      try {
        let payload = {
          id: params.id,
          requested_info: replayData,
          action: "INFO_REQUESTED",
          additional_req_id: requestId ? requestId : null,
        };
        const messageData = await OndcService.updateNeedMoreInfo(payload);
        setReplayTicket(false);
        setLoading(false);
        loadTickets();
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Please Enter All Fields");
    }
  };

  const resolveIssue = async () => {
    setLoading(true);
    try {
      let payload = {
        id: params.id,
      };
      const messageData = await OndcService.resolveIssue(payload);
      setLoading(false);
      loadTickets();
    } catch (error) {
      setLoading(false);
    }
  };

  const OncancelReplyOption = () => {
    setReplayTicket(false);
  };

  const onSubmitResolution = async () => {
    let payload = {
      id: params.id,
      item: resolutionData.item,
      refund_amt: resolutionData.refund_amt,
      description: resolutionData.description
    }
    if (payload.item && payload.refund_amt) {
      setLoading(true);
      try {
        const messageData = await OndcService.sendIssueResolutions(payload);
        setResolutionData({
          item: "",
          refund_amt: "",
          description: ""
        });
        setResolution(false);
        setLoading(false);
        loadTickets();
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Please Enter All Fields");
    }
  }
  const OncancelResolutionOption = () => {
    setResolution(false);
    setResolutionData({
      refund_amt: "",
      description: ""
    });
  }

  const handleInput = (e: any) => {
    setReplayData(e.target.value);
  };

  const [breadcrumbInfo, setBreadcrumbInfo] = useState<any>([
    {
      label: "Tickets",
      value: "Tickets",
      routerLink: `/dashboard/ondc-igm`,
      isActive: false,
    },
    {
      label: "Info",
      value: "Info",
      routerLink: ``,
      isActive: true,
    },
  ]);
  const handleSelect = (e: any) => {
    setActionData(e.target.value);
  };

  const handleResolutionValues = (value: string, field: string) => {
    setResolutionData((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const selectRequestId = (id: string) => {
    setRequestId(id);
  }

  return (
    <div className="container-fluid content-bg-color">
      <Breadcrumb breadCrumbList={breadcrumbInfo} />
      {!loading ? (
        <div>
          <h5 className="fw-600">Ticket ID : {params.id}</h5>
          <div className="card mb-2">
            <div className="card-body">
              <h6 className="fw-bold fs-5 mb-2">Ticket details</h6>

              <div className="row">
                <div className="col-md-4 mb-2">
                  <h6 className="fw-bold mb-0 mt-2">Ticket ID</h6>
                  <div className="fs-14">{ticketsData?._id}</div>
                </div>
                <div className="col-md-4 mb-2">
                  <h6 className="fw-bold mb-0 mt-2">Created</h6>
                  <div className="fs-14">
                    {FormatIndianDate(ticketsData?.created_dt, "")}
                  </div>
                </div>
                <div className="col-md-4 mb-2">
                  <h6 className="fw-bold mb-0 mt-2">Issue Type</h6>
                  <div className="fs-14">
                    {ticketsData?.message?.issue?.issue_type}
                  </div>
                </div>
                <div className="col-md-4 mb-2">
                  <h6 className="fw-bold mb-0 mt-2">Transaction Id</h6>
                  <div className="fs-14">
                    {ticketsData?.processing?.context?.transaction_id ||
                      ticketsData?.context?.transaction_id}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {ticketsData?.message?.issue?.order_details && <div className="card mb-2">
            <div className="card-body">
              <h6 className="fw-bold fs-5 mb-2">Order Details</h6>
              <div className="row">
                <div className="col-md-3 mb-2">
                  <h6 className="fw-bold mb-0 mt-2">Order Id</h6>
                  <div className="fs-14">{ticketsData?.message?.issue?.order_details?.id}</div>
                </div>
                <div className="col-md-3 mb-2">
                  <h6 className="fw-bold mb-0 mt-2">Provider Name</h6>
                  <div className="fs-14">{userData?.business_name}</div>
                </div>
                <div className="col-md-3 mb-2">
                  <h6 className="fw-bold mb-0 mt-2">Provider Contact</h6>
                  <div className="fs-14">{userData?.mobile_number}</div>
                </div>
              </div>
              <h6 className="fw-bold fs-6 mb-2">Product Details</h6>
              {productsData && productsData.map((product:any,index:any)=>(<div key={index} className="row align-items">
                <div className="col-md-2"><img src={product?.images ? `${IMAGE_PATH}/${product?.images || noImage}`:noImage} alt="product image"
                        className={(product?.images) ? "rounded object-fit-cover":"rounded object-fit-contain"}
                        style={{ height: "100px" }}/></div>
                <h6 className="col-md-10 fw-bolder">{product?.name}</h6>
              </div>))}
            </div>
          </div>}
          <div>
            {!replayTicket && !resolution ? (
              <div className="text-end">
                <button
                  className="primary-bg rounded px-4 py-1 text-white border-0 my-3 me-2"
                  onClick={() => resolveIssue()}
                >
                  Resolve
                </button>
                <button
                  className="primary-bg rounded px-4 py-1 text-white border-0 my-3 me-2"
                  onClick={sendResolution}
                >
                  Send Resolution
                </button>
                <button
                  className="primary-bg rounded px-4 py-1 text-white border-0 my-3"
                  onClick={writeReplay}
                >
                  Reply
                </button>
              </div>
            ) : (
              <div className="my-3 card">
                <div className="card-body">
                  {replayTicket ? (<div>
                    <div className="form-group">
                      <label
                        htmlFor="exampleFormControlSelect1"
                        className="fw-600"
                      >
                        Action
                      </label>
                      <select
                        className="form-control fs-14"
                        id="exampleFormControlSelect1"
                        onChange={(e) => handleSelect(e)}
                      >
                        <option value="">Select your action</option>
                        <option value="PROCESSING">Processing</option>
                        <option value="CASCADED">Cascaded</option>
                        <option value="RESOLVED">Resolved</option>
                        <option value="NEED-MORE-INFO">Need-More-Info</option>
                      </select>
                    </div>
                    <label className="fw-600">Write your reply here</label>
                    <textarea
                      className="form-control"
                      id="exampleTextarea"
                      placeholder="Enter your message here"
                      onChange={(e) => handleInput(e)}
                    ></textarea>
                    {actionData === "NEED-MORE-INFO" && <div className="row mt-2">
                      {ticketsData?.additional_reqs && <label className="fw-600">Select Additional Request Id</label>}
                      {ticketsData?.additional_reqs && ticketsData?.additional_reqs?.map((req: any, index: number) => (
                        <div className="col-4" key={index}>
                          <Card className={`mb-2 cursor-pointer ${requestId === req.id ? "primary-border" : ""}`} onClick={() => selectRequestId(req.id)}>
                            <Card.Body>
                              {req?.id}
                            </Card.Body>
                          </Card>
                        </div>
                      ))
                      }
                    </div>}
                    <div className="text-end mt-2">
                      <button
                        className="primary-bg rounded px-4 py-1 text-white primary-border mb-3 mt-1"
                        onClick={onSubmitData}
                      >
                        Submit
                      </button>
                      <button
                        className="primary-border rounded px-4 py-1 primary-color bg-white ms-2 mb-3 mt-1"
                        onClick={OncancelReplyOption}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>) : (<div>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <label className="fw-600">Item Id <span className="text-danger">*</span></label>
                        <input type="text" className="form-control fs-14" placeholder="enter item id" onChange={(e) => handleResolutionValues(e.target.value, "item")} value={resolutionData.item} />
                      </div>
                      <div className="col-md-6  mb-2">
                        <label className="fw-600">Refund Amount <span className="text-danger">*</span></label>
                        <input type="number" className="form-control fs-14" placeholder="please enter refund amount" value={resolutionData.refund_amt} onChange={(e) => handleResolutionValues(e.target.value, "refund_amt")} />
                      </div>
                      <div className="col-md-12">
                        <label className="fw-600">Description</label>
                        <textarea
                          className="form-control fs-14"
                          id="exampleTextarea"
                          placeholder="enter your message here"
                          value={resolutionData.description}
                          onChange={(e) => handleResolutionValues(e.target.value, "description")}
                        ></textarea>
                      </div>
                    </div>
                    <div className="text-end mt-2">
                      <button
                        className="primary-bg rounded px-4 py-1 text-white primary-border mb-3 mt-1"
                        onClick={onSubmitResolution}
                      >
                        Submit
                      </button>
                      <button
                        className="primary-border rounded px-4 py-1 primary-color bg-white ms-2 mb-3 mt-1"
                        onClick={OncancelResolutionOption}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>)}
                </div>
              </div>
            )}
          </div>
          <div className="card border-30 box-shadow rounded">
            <div className="card-body">
              <div className="row align-items">
                <div className="col-4 ">
                  <div>
                    {
                      ticketsData?.message?.issue?.complainant_info?.person
                        ?.name
                    }
                  </div>
                  <div>
                    {
                      ticketsData?.message?.issue?.complainant_info?.contact
                        ?.phone
                    }
                  </div>
                  <div>
                    {
                      ticketsData?.message?.issue?.complainant_info?.contact
                        ?.email
                    }
                  </div>
                  <div className="fs-14">
                    {FormatIndianDate(
                      ticketsData?.message?.issue?.created_at,
                      "datetime"
                    )}
                  </div>
                </div>
                <div className="col-8 fs-14 border-start">
                  {(ticketsData?.message?.issue?.description?.short_desc || ticketsData?.message?.issue?.descriptor?.short_desc) && (
                    <>
                      <h6 className="fw-bold mb-0">short description</h6>
                      <p className="mb-2">{ticketsData?.message?.issue?.description?.short_desc || ticketsData?.message?.issue?.descriptor?.short_desc}</p>
                    </>
                  )}
                  {(ticketsData?.message?.issue?.description?.long_desc || ticketsData?.message?.issue?.descriptor?.long_desc) && (
                    <>
                      <h6 className="fw-bold mb-0">long description</h6>
                      <p className="mb-2">{ticketsData?.message?.issue?.description?.long_desc || ticketsData?.message?.issue?.descriptor?.long_desc}</p>
                    </>
                  )}
                  {(ticketsData?.message?.issue?.description?.additional_desc || ticketsData?.message?.issue?.descriptor?.additional_desc) && (
                    <>
                      <h6 className="fw-bold mb-0">additional description</h6>
                      {(ticketsData?.message?.issue?.description?.additional_desc?.content_type?.includes("image") || ticketsData?.message?.issue?.descriptor?.additional_desc?.content_type?.includes("image")) ? <img src={(ticketsData?.message?.issue?.description?.additional_desc?.url || ticketsData?.message?.issue?.descriptor?.additional_desc?.url)} alt="image not found" className="w-100-h-100" /> : <p>{(ticketsData?.message?.issue?.description?.additional_desc?.url || ticketsData?.message?.issue?.descriptor?.additional_desc?.url)}</p>}

                    </>
                  )}
                  {(ticketsData?.message?.issue?.description?.images?.length > 0 || ticketsData?.message?.issue?.descriptor?.images?.length > 0) && (
                    <>
                      <h6 className="fw-bold mb-0">More Images</h6>
                      <>
                        {ticketsData?.message?.issue?.description?.images?.map((image: any, index: any) => (
                          <img key={index} src={image || image?.url} alt="image not found" className="w-100-h-100 mt-1" />
                        ))}
                        {ticketsData?.message?.issue?.descriptor?.images?.map((image: any, index: any) => (
                          <img key={index} src={image?.url || image} alt="image not found" className="w-100-h-100 mt-1" />
                        ))}
                      </>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-center p-5">
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
